// extracted by mini-css-extract-plugin
export default {"image":"Sda-z","loaded":"Tda-z"};